import { useContext } from 'react';
import { PromptContext } from '../PromptContext';

export const usePromptContext = () => {
  const context = useContext(PromptContext);

  if (!context) {
    throw new Error(
      'PromptContext must be used within a PromptContextProvider'
    );
  }
  return context;
};
